/**
 * UNBEGUN Premium Navigation configuration
 *
 * Match items by their stable Shopify path, not by the translated menu title.
 * Remove a badge line completely when you no longer want to show it.
 */
window.UnbegunMenuConfig = Object.freeze({
  featured: Object.freeze({
    path: '/collections/macbook-neo-sleeve',
    badge: 'new'
  }),

  badges: Object.freeze({
    // Example:
    // '/products/flight-bag': 'limited'
  })
});
